// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__uoviK","header":"Messages_header__2uvjp"};